import React, {} from 'react';
const styles = {"band":"ClosingBand-module__band__E0DHc","title":"ClosingBand-module__title__U-aIc"};
const TITLE_ID = 'closing-band-title';
/** The dark navy band at the end of the landing page: a last large title and the call to action. */
export function ClosingBand({ title, action }) {
    return (React.createElement("section", { className: styles.band, "aria-labelledby": TITLE_ID },
        React.createElement("h2", { className: styles.title, id: TITLE_ID }, title),
        action));
}
//# sourceMappingURL=ClosingBand.js.map